export const REDUCER_NAME = 'CivilRegistry'

export const actions = {
  client: {
    FETCH: 'CivilRegistry/FETCH',
    FETCH_SUCCESS: 'CivilRegistry/FETCH_SUCCESS',
    FETCH_FAILURE: 'CivilRegistry/FETCH_FAILURE',
  },
  data: {
    FETCH_SUCCESS: 'clients/FETCH_SUCCESS',
  },
}
